module.exports = __webpack_public_path__ + "static/img/xnkt.aff4ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/xnkt.png
// module id = kDYJ
// module chunks = 5